import { Box } from "@chakra-ui/react";

import { TSelectOptionType } from "@components/Select/types";

import { TLockerEntry } from "../types";

const mapLockersToOptions = (lockers: TLockerEntry[]): TSelectOptionType[] =>
  lockers.map(({ id: lockerId, name, city, country, postalCode, street }) => {
    const displayLabel = (
      <Box>
        <Box>{name}</Box>
        <Box sx={{ fontSize: "0.75rem" }}>{[street, postalCode, city, country].filter(Boolean).join(", ")}</Box>
      </Box>
    );
    return { label: name, displayLabel, value: lockerId };
  });
export default mapLockersToOptions;
